import { getServiceUrl } from '../api.config';
import { ApiClientOptions } from '../types/api';
import ApiClient from '../utils/ApiClient';
import { isNotEmptyString } from '../utils/validators';

export default class MailDomainApi extends ApiClient {
  public constructor(options?: ApiClientOptions) {
    super(getServiceUrl('auth'), options);
  }

  // --------------------------------------------------------------------------
  // MailDomain
  // --------------------------------------------------------------------------

  public MailDomainList() {
    const query = '/auth/v2/organizationownsmaildomain';
    return this.get(query);
  }

  public MailDomainCreate(mailDomain?: string) {
    const query = '/auth/v2/organizationownsmaildomain';
    const data: any = {};

    if (isNotEmptyString(mailDomain)) {
      data.domain = mailDomain;
    }

    return this.post(query, data);
  }

  public MailDomainDelete(mailDomain?: string) {
    const query = '/auth/v2/organizationownsmaildomain';
    const data: any = {};

    if (isNotEmptyString(mailDomain)) {
      data.domain = mailDomain;
    }

    return this.delete(query, data);
  }
}
